import "./PieCharts.css"
import React from "react";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import 'chartjs-plugin-datalabels'
// import Divider from "@mui/material/Divider";
import { ProgressSpinner } from "primereact/progressspinner";
import { toast } from "../../../components/Toast/toast.ts";
import { useUserContext } from '../../..//context/UserContext.tsx';
ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieCharts() {
    const [Data, setData] = React.useState([])
    const [isLoading, setLoading] = React.useState(false)
    const { handleTokenExpired } = useUserContext();
    // const [high, setHigh] = React.useState(0)
    // const [medium, setMedium] = React.useState(0)
    // const [low, setLow] = React.useState(0)
    //const documentStyle = getComputedStyle(document.documentElement);

    const data = {
        datasets: [
            {
                data: Data,
                backgroundColor: [
                    '#FD5E48',  //red
                    "#1AACAC"    //green  
                ],
                hoverBackgroundColor: [
                    '#FD5E48',
                    "#1AACAC"
                ],
            },
        ],
    };
    const options = {
        cutout: '50%',
        reponsive: true,
        rotation: -90, // Rotate the chart to start from the top
        circumference: 180,
    };

    const storedToken = localStorage.getItem('token');

    React.useEffect(() => {

        const fetchCount = async () => {
            if (storedToken) {
                try {
                    setLoading(true)
                    let response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cust-portal/severity-report`,
                        {
                            headers: {
                                Authorization: `Bearer ${storedToken}`,
                            },
                        }
                    )
                    let arr: any = []
                    for (let i = 0; i < response?.data?.length; i++) {
                        if (response?.data[i]?._id === "High") {
                            arr[0] = response?.data[i]?.count
                            // setHigh(response?.data[i]?.count)
                        }
                        if (response?.data[i]?._id === "Medium") {
                            arr[1] = response?.data[i]?.count
                            // setMedium(response?.data[i]?.count)
                        }
                    }
                    setData(arr);
                    setLoading(false)
                } catch (error) {
                    // toast.error(error?.response?.data?.message || error?.message || "Unable to retrieve charts data. Please try again.")
                    const errorMessage = error?.response?.data?.message || error?.message || "An error occurred. Please try again.";

                    if (errorMessage !== "Token Expired") {
                        toast.error(errorMessage);
                    }

                    if (errorMessage === "Token Expired") {
                        handleTokenExpired();
                    }
                    setLoading(false)
                }
            }
        }
        fetchCount()
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <div className="apiGateway-maincontainer">
                {isLoading ?
                    <ProgressSpinner style={{ width: '65px', height: '65px', display: 'flex', marginTop: '40px', justifyContent: 'center', alignItems: 'center' }}
                        strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
                    : <>
                        <div className="apiGatewayPieChart">
                            <Doughnut data={data} options={options} style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center" }} />
                        </div>
                    </>}
            </div >
        </>
    )
}



